var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 14,
    viewBox: "0 0 83 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89128 0.989258L8.64197 4.759L12.7682 5.2591L9.72396 8.08902L10.5234 12.1678L6.89128 10.1471L3.25914 12.1678L4.0586 8.08902L1.01435 5.2591L5.14059 4.759L6.89128 0.989258Z",
    fill: "#004424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8005 0.989258L24.5512 4.759L28.6774 5.2591L25.6331 8.08902L26.4326 12.1678L22.8005 10.1471L19.1683 12.1678L19.9678 8.08902L16.9235 5.2591L21.0498 4.759L22.8005 0.989258Z",
    fill: "#004424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7096 0.989258L40.4603 4.759L44.5866 5.2591L41.5423 8.08902L42.3418 12.1678L38.7096 10.1471L35.0775 12.1678L35.877 8.08902L32.8327 5.2591L36.9589 4.759L38.7096 0.989258Z",
    fill: "#004424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6188 0.989258L56.3695 4.759L60.4957 5.2591L57.4515 8.08902L58.251 12.1678L54.6188 10.1471L50.9867 12.1678L51.7861 8.08902L48.7419 5.2591L52.8681 4.759L54.6188 0.989258Z",
    fill: "#004424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.529 0.989258L72.2797 4.759L76.4059 5.2591L73.3617 8.08902L74.1611 12.1678L70.529 10.1471L66.8968 12.1678L67.6963 8.08902L64.652 5.2591L68.7783 4.759L70.529 0.989258Z",
    fill: "#004424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutStars);
export default __webpack_public_path__ + "static/media/about-stars.7fc216dd3a8fb939b43b0fa59fb425cd.svg";
export { ForwardRef as ReactComponent };